/* tslint:disable:variable-name */
import $ = require('jquery');
import Modul from './Modul';
import l10n = require('diy/util/l10n');

interface Marker extends google.maps.Marker {
    info_window: google.maps.InfoWindow;
    Gp: string;
}

/**
 * Google Maps module
 */
export default class ModulGooglemaps extends Modul {
    /**
     * Achtung: Die im Code benutzten Variablen Gp und Tp sind
     * undokumentiert. Gp ist ein Attribut der Marker-Objekte und trägt
     * einen String mit dem internen Namen; Tp ist ein Attribut des
     * Karten-Objekts und trägt ein Array mit allen Overlay-Objekten,
     * die auf der Karte platziert sind. Die Variablennamen Gp und Tp
     * sind generiert, das heißt, dass sie bei jedem Googlemaps-Update
     * einen neuen Namen erhalten können. Wenn wir unser Modul auf eine
     * neue Version updaten, müssen wir also im DOM nach den jeweils
     * neuen Namen suchen.
     */
    map: google.maps.Map = null;
    marker: Marker = null;
    markers: {
        [index: number]: Marker;
        [index: string]: Marker;
    } = {};

    // Array mit GoogleMaps Pointer Namen für Marker
    marker_Gp: string[] = [];
    marker_link = '';
    geocoder: google.maps.Geocoder = null;

    // Array mit allen Marker-Daten, wegen besserer
    // Bearbeitungsmöglichkeiten
    // eindimensional gehalten. Wird pro Marker wie folgt gefüllt:
    // [0] Interner Name String
    // [1] Titel String
    // [2] Beschreibung String
    // [3] Position Array(int, int)
    // [4] Link String
    // [5] Adresse String
    marker_array: (string|[number, number])[] = [];

    // Höhen- und Breitengrad der letzten Maps-Suche
    saved_pos: google.maps.LatLng = null;

    // Maximalbreite eines InfoWindows
    maxwidth = 380;

    // Standardname einer Ortsmarke
    stdmarker: string = null;

    // Schränkt den Drag-Listener des Markers auf einen Durchgang pro
    // Drag ein
    listenondrag = true;

    // Variablen für die Kontrollelemente
    hasInitialAddress = false;

    constructor(moduleId: number) {

        super(moduleId);

        $('.gmapsearch-button').button();
        $('#mapRoutes_' + moduleId).diy_checkbox();
        $('.gmarker-center').button({
            icons: {
                primary: 'ui-icon-gmarker'
            }
        });
        $('.gmarker-search').button({});

        $("input#maps_search_" + moduleId).diy_textField();
        this.form = $("input#maps_search_" + moduleId).closest('form').diy_form({
            messageTarget: '.form-error'
        });

        let initialAddress = $('input#maps_search_initialAddress_' + moduleId).val();
        if (typeof initialAddress !== 'undefined' && initialAddress !== null && initialAddress.length > 0) {
            $('#maps_search_' + moduleId).val(initialAddress);
            this.hasInitialAddress = true;
        };
    }

    save() {
        // Beim Speichern des Moduls die Daten für den
        // Modul-Update-Prozess in versteckte Input-Felder stecken

        //height
        let mapHeight = $('#mapHeight_' + this.moduleId).val();
        $('#hidden_mapHeight_' + this.moduleId).val(mapHeight);
        let position = this.map.getCenter().lat() + ',' +
                this.map.getCenter().lng() + ',' + this.map.getZoom();
        for (let i = 0; i < this.marker_array.length; i += 6) {
            (this.marker_array[i + 3] as [number, number])[0] = "" as any +
                    this.marker_array[i + 3][0];
            (this.marker_array[i + 3] as [number, number])[1] = "" as any +
                    this.marker_array[i + 3][1];
        }
        let markers = JSON.stringify(this.marker_array);
        $('#position_' + this.moduleId).val(position);
        $('#markers_' + this.moduleId).val(markers);

        if ($('#mapcontrolZoom_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_control_' + this.moduleId).val(1);
        }
        if ($('#maptype_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_type_' + this.moduleId).val(1);
        }
        if ($('#mapscale_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_scale_' + this.moduleId).val(1);
        }
        if ($('#mapoverview_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_overview_' + this.moduleId).val(1);
        }

        let tempmodule = this;

        //remember map type
        let mapType = this.map.getMapTypeId();
        let mapTypeId = 0;
        switch (mapType) {
        case google.maps.MapTypeId.ROADMAP:
            mapTypeId = 0;
            break;
        case google.maps.MapTypeId.SATELLITE:
            mapTypeId = 1;
            break;
        case google.maps.MapTypeId.HYBRID:
            mapTypeId = 2;
            break;
        case google.maps.MapTypeId.TERRAIN:
            mapTypeId = 3;
            break;
        default:
            break;
        }

        $('#map_type_default_' + tempmodule.moduleId).val(mapTypeId);

        if ($('#mapRoutes_' + this.moduleId).prop('checked') === true) {
            $('#hidden_mapRoutes_' + this.moduleId).val(1);
        } else {
            $('#hidden_mapRoutes_' + this.moduleId).val(0);
        }
        return super.save();
    }

    getMapControlsPreset(preset: string) {
        let mapControlsPresets: { [presetName: string]: google.maps.MapOptions } = {
            removeZoomMapControls: {
                zoomControl: false
            },
            addZoomMapControls: {
                zoomControl: true
            },
            removeMapTypesControls: {
                mapTypeControl: false
            },
            addMapTypesControls: {
                mapTypeControl: true
            },
            removeScaleControls: {
                scaleControl: false
            },
            addScaleControls: {
                scaleControl: true
            },
            removeMapOverviewControls: {
                overviewMapControl: false
            },
            addMapOverviewControls: {
                overviewMapControl: true,
                overviewMapControlOptions: {opened: true}
            }

        };
        return mapControlsPresets[preset];
    }

    setMapControls(options: google.maps.MapOptions) {
        if (this.map == null) {
            return false;
        }
        this.map.setOptions(options);
        return true;
    }
    //resets the map controls according to the elements in editor
    resetMapControls() {
        let options = {};
        let otherControlsEl = $('.map_nav_option a', this.getEditorContainer());
        if (otherControlsEl.length) {
            let s = this;
            otherControlsEl.each(function(index, element) {
                let $el = $(element);
                let controls = $el.attr('data-mapPreset');
                if ($el.hasClass('map-control-active')) {
                    controls = 'add' + controls;
                } else {
                    controls = 'remove' + controls;
                }
                $.extend(options, s.getMapControlsPreset(controls));
            });
        }
        this.setMapControls(options);
    }
    selectOption(id: string) {
        $('.map_nav_options a', this.getEditorContainer()).each((index, el) => {
            let $el = $(el);
            let mapPreset = $el.attr('data-mapPreset');
            if ( mapPreset === id) {
                //set this one as active
                $el.addClass('map-control-active');
            } else {
                //this one is not active
                $el.removeClass('map-control-active');
            }
        });
        this.setMapControls(this.getMapControlsPreset(id));
    }
    clickOption(id: string) {
        //get the element
        let el = $('.map_nav_option a.' + id, this.getEditorContainer());
        let mapPreset = el.attr('data-mapPreset');

        if (el.hasClass('map-control-active')) {
            el.removeClass('map-control-active');
            mapPreset = 'remove' + mapPreset;
        } else {
            el.addClass('map-control-active');
            mapPreset = 'add' + mapPreset;
        }

        this.setMapControls(this.getMapControlsPreset(mapPreset));

    }
    loadMap() {

        let this_module = this;
        let data_url = systemurl + 'app/module/googlemaps/fetchdata';
        let post_data = 'moduleId=' + this.moduleId;
        $.post(data_url, post_data, function(response) {
            this_module.stdmarker = response.stdmarker;
            //prepare the options for the map
            let map_lat = parseFloat(response.position[0]);
            let map_lng = parseFloat(response.position[1]);
            let map_zoom = parseInt(response.position[2], 10);
            //TODO: check that all old map types are available
            /**
             * old map type constants vs. new ones
             *
             * G_NORMAL_MAP     <->     ROADMAP
             * G_SATELLITE_MAP  <->     SATELLITE
             * G_HYBRID_MAP     <->     HYBRID
             * G_PHYSICAL_MAP   <->     TERRAIN
             */
            let map_type_id = google.maps.MapTypeId.ROADMAP;

            switch (parseInt(response.maptype, 10)) {
            case 0:
                map_type_id = google.maps.MapTypeId.ROADMAP;
                break;
            case 1:
                map_type_id = google.maps.MapTypeId.SATELLITE;
                break;
            case 2:
                map_type_id = google.maps.MapTypeId.HYBRID;
                break;
            case 3:
                map_type_id = google.maps.MapTypeId.TERRAIN;
                break;
            default:
                break;
            }

            //init the map
            let map_canvas = document.getElementById('map_canvas_' + this_module.moduleId);
            let map_options = {
                    center: new google.maps.LatLng(map_lat, map_lng),
                    zoom: map_zoom,
                    mapTypeId: map_type_id,
                    scrollwheel: true,
                    mapTypeControlOptions: {
                        mapTypeIds: [google.maps.MapTypeId.ROADMAP,
                                    google.maps.MapTypeId.SATELLITE,
                                    google.maps.MapTypeId.HYBRID,
                                    google.maps.MapTypeId.TERRAIN],
                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
                    },
                    streetViewControl: false
            };

            this_module.map = new google.maps.Map(map_canvas, map_options);

            //change controls
            this_module.resetMapControls();

            //geocoder
            this_module.geocoder = new google.maps.Geocoder();

            this_module.marker_array = response.markers;
            this_module
                    .loadMarkers(response.infowindows);
            // Standardnamen einer Ortsmarke
            // speichern (per AJAX wegen
            // Übersetzungen)
            this_module.stdmarker = response.stdmarker;

            if (this_module.hasInitialAddress) {
                this_module.searchMap();
            }
        }, 'json');
    }
    changeCopyrightPosition(tempmodule: ModulGooglemaps) {
        if ($('#map_canvas_' + tempmodule.moduleId).find(
                '#logocontrol').next('div').length > 0) {
            $('#map_canvas_' + tempmodule.moduleId).find(
                    '#logocontrol').next('div').css({
                'white-space' : 'normal',
                'margin-left' : '60px'
            });
        } else {
            setTimeout(function() {
                tempmodule.changeCopyrightPosition(tempmodule);
            }, 100);
        }
    }
    searchMap() {
        //v3:
        //make sure the error is off.
        this.form.diy_form('clearErrors');
        let map_search_error_msg =  $("#maps_search_error_" + this.moduleId).text();

        //search the location
        let addrToSearch = $('#maps_search_' + this.moduleId).val();
        if (addrToSearch === '') {
            this.form.diy_form('addError', map_search_error_msg, '#maps_search_' + this.moduleId );
            return;
        }
        let geoReq = {'address' : addrToSearch};
        let this_module = this;
        this.geocoder.geocode(geoReq, function(results, status) {
            //if success, go to that location, and show search marker....
            if (status === google.maps.GeocoderStatus.OK) {
                let accuracy = results[0].geometry.location_type;
                switch (accuracy) {
                case google.maps.GeocoderLocationType.GEOMETRIC_CENTER:
                    this_module.map.setZoom(12);
                    break;
                case google.maps.GeocoderLocationType.RANGE_INTERPOLATED:
                    this_module.map.setZoom(14);
                    break;
                case google.maps.GeocoderLocationType.ROOFTOP:
                    this_module.map.setZoom(16);
                    break;
                //case google.maps.GeocoderLocationType.APPROXIMATE:
                default:
                    this_module.map.setZoom(10);
                    break;

                }
                //decide zoom from accuracy
                //center to that location
                this_module.map.setCenter(results[0].geometry.location);
                //temp-save the position
                this_module.saved_pos = results[0].geometry.location;
                $('#maps_search_' + this_module.moduleId)
                    .val(results[0].formatted_address);
                $('#maps_search_marker_' + this_module.moduleId).show();
                $('#maps_search_form_' + this_module.moduleId).show();

            } else {
                //if fail, show the error, hide search marker
                this_module.form.diy_form('addError', map_search_error_msg, '#maps_search_' + this_module.moduleId );
                $('#maps_search_marker_' + this_module.moduleId).hide();
                $('#maps_search_form_' + this_module.moduleId).hide();
            }
        });

        return; //end v3

    }
    setMarker(latlng: google.maps.LatLng) {
        let this_module = this;
        for (let k in this.markers) {
            if (this.markers.hasOwnProperty(k)) {
                this.markers[k].info_window.close();
            }
        }
        //v3:
        let address = '';
        let title: string;
        if (!latlng) {
            latlng = this.map.getCenter();
            title = this.stdmarker;
        } else {
            title = $('#maps_search_' + this.moduleId).val();
            address = title;
            $('#maps_search_' + this.moduleId).val('');
            $('#maps_search_marker_' + this.moduleId).hide();
            $('#maps_search_form_' + this_module.moduleId).hide();
        }
        //add the marker
        let marker = new google.maps.Marker({
            map: this.map,
            position: latlng,
            clickable: true,
            draggable: true
        }) as Marker;
        //info window

        let info_window = new google.maps.InfoWindow({
            maxWidth: this.maxwidth
        });

        this.getHtml(1, title, '', '', address, latlng.lat(),
                latlng.lng(), function(html: string) {

            info_window.setContent(html);
            info_window.open(this_module.map, marker);
            this_module.infoWindowContentUI();
        });

        //do some other shit to keep this monster working
        marker.info_window = info_window;

        this.marker = marker;
        this.marker_link = '';
        let nextIndex = this.getMapNextIndex();

        this.markers[nextIndex] = marker;

        this.marker_Gp.push('Gp' + nextIndex);
        this.marker.Gp = this.marker_Gp[this.marker_Gp.length - 1];
        this.marker_array.push(
                this.marker_Gp[this.marker_Gp.length - 1], title, '', [
                        latlng.lat(),
                        latlng.lng() ], '', address);
        this.updateMarkerList();
        this.addMarkerListeners(this.marker);

        //show the window on click
        google.maps.event.addListener(marker, 'click', function() {
            //close other windows
            for (let k in this_module.markers) {
                if (this_module.markers.hasOwnProperty(k)) {
                    this_module.markers[k].info_window.close();
                }
            }
            this_module.marker = marker;
            info_window.open(this_module.map, marker);
            this_module.infoWindowContentUI();
        });

        return; //end v3

    }
    getMapNextIndex() {
        if (this.marker_Gp.length === 0) {
            return 0;
        }

        return parseInt(this.marker_Gp[this.marker_Gp.length - 1].substr(2), 10) + 1;
    }
    saveMarkerContent() {
        /* Marker-Inhalt im Array updaten */
        let index = this.marker_array.indexOf(this.marker.Gp);
        this.marker_array[index + 1] = $('#marker_title').val();
        this.marker_array[index + 2] = $('#marker_content').val();
        this.marker_array[index + 4] = this.marker_link;
        this.updateMarkerList();
        /* InfoWindow updaten */
        let tempmodule = this;
        this.getHtml(2, this.marker_array[index + 1],
                this.marker_array[index + 2],
                this.marker_array[index + 4],
                this.marker_array[index + 5],
                (this.marker_array[index + 3] as [number, number])[0],
                (this.marker_array[index + 3] as [number, number])[1],
                function(html: string) {
                    //set info and open it
                    //v3:
                    if (tempmodule.marker.info_window != null) {
                        tempmodule.marker.info_window.setContent(html);

                        tempmodule.infoWindowContentUI();
                    }
                    //end v3

                });
    }
    editMarker() {
        /*
         * Marker-Titel und -Inhalt anhand des Marker-Namen aus dem
         * Array holen
         */
        let index = this.marker_array.indexOf(this.marker.Gp);
        let title = this.marker_array[index + 1];
        let content = this.marker_array[index + 2];
        let link = this.marker_array[index + 4];

        /* InfoWindow updaten */
        let tempmodule = this;
        this.getHtml(1, title, content, link,
                this.marker_array[index + 5],
                (this.marker_array[index + 3] as [number, number])[0],
                (this.marker_array[index + 3] as [number, number])[1],
                function(html: string) {
                    //v3:
                    tempmodule.marker.info_window.setContent(html);

                    tempmodule.infoWindowContentUI();

                    //end v3

                });
    }
    removeMarker() {
        /* Marker-Namen, -Titel und -Inhalt aus dem Array werfen */
        let index = this.marker_array.indexOf(this.marker.Gp);
        if (index === 0) {
            this.marker_Gp.splice(0, 1);
        } else {
            this.marker_Gp.splice((index / 6), 1);
        }
        this.marker.Gp = null;
        this.marker_array.splice(index, 6);
        this.updateMarkerList();
        /* Marker von der Karte entfernen */
        this.marker.setMap(null);
    }
    updateMarkerList() {
        /*
         * Relevante Daten aus dem Marker-Array filtern und nach Titel
         * sortieren
         */
        let list: { name: string|[number, number]; title: string|[number, number]; }[] = [];
        for (let i = 0; i < this.marker_array.length; i += 6) {
            list.push({
                name : this.marker_array[i],
                title : this.marker_array[i + 1]
            });
        }
//                    list.sort(function(a, b) {
//                        if (a.title.toLowerCase() < b.title.toLowerCase()) {
//                            return -1;
//                        }
//                        if (a.title.toLowerCase() >= b.title.toLowerCase()) {
//                            return 1;
//                        }
//                    });
        /* Marker-Liste aktualisieren */
        let options = '';
        $.each(list, function(key, item) {
            options += '<option value="' + item.name + '">' +
                    item.title + '</option>';
        });
        $('#marker_list_' + this.moduleId).html(options);
    }
    panToMarker() {
        //close all markers
        //v3:
        for (let k in this.markers) {
            if (this.markers.hasOwnProperty(k)) {
                this.markers[k].info_window.close();
            }
        }
        //end v3
        /*
         * Karte zur Position des in der Liste ausgewählten Markers
         * bewegen
         */
        let index = this.marker_array.indexOf($(
                '#marker_list_' + this.moduleId).val());
        if (index >= 0) {
            let position = this.marker_array[index + 3] as [number, number];

            this.map.panTo(new google.maps.LatLng(position[0], position[1]));
        }
    }
    loadMarkers(infowindow_data: string[]) {

        let this_module = this;
        //v3:
        for ( let i = 0; i < this.marker_array.length; i += 6) {
            //create the marker
            let pos = new google.maps.LatLng(
                (this.marker_array[i + 3] as [number, number])[0],
                (this.marker_array[i + 3] as [number, number])[1]
            );
            let marker = new google.maps.Marker({
                map: this.map,
                position: pos,
                clickable: true,
                draggable: true
            }) as Marker;
            let html = infowindow_data[i / 6];
            let info_window = new google.maps.InfoWindow({
                maxWidth: this.maxwidth
            });

            info_window.setContent(html);

            marker.info_window = info_window;
            this.marker = marker;
            this.markers[this.marker_array[i] as string] = marker;

            this.addMarkerListeners(marker);
            (function(marker: Marker, info_window: google.maps.InfoWindow) {
                google.maps.event.addListener(marker, 'click', function() {
                    for (let k in this_module.markers) {
                        if (this_module.markers.hasOwnProperty(k)) {
                            this_module.markers[k].info_window.close();
                        }
                    }
                    this_module.marker = marker;
                    info_window.open(this_module.map, marker);

                    this_module.infoWindowContentUI();
                });
            })(marker, info_window);

            if (i === 0) {
                this.marker_Gp[0] = this.marker_array[i] as string;
                this.marker.Gp = this.marker_Gp[0];
            } else {
                this.marker_Gp[i / 6] = this.marker_array[i] as string;
                this.marker.Gp = this.marker_Gp[i / 6];
            }

        }
        this.updateMarkerList();
        return; //end v3

    }
    addMarkerListeners(marker: Marker) {
        let tempmodule = this;
        //v3:
        //on drag end, update the marker array
        google.maps.event.addListener(marker, 'dragend', function() {
            tempmodule.marker_array[tempmodule.marker_array
                                    .indexOf(marker.Gp) + 3] = [
                                    marker.getPosition().lat(),
                                    marker.getPosition().lng() ];
        });

        return; //end v3

    }
    getHtml(
        type: number,
        title: string | [number, number],
        content: string | [number, number],
        link: string | [number, number],
        address: string | [number, number],
        lat: number,
        lng: number,
        callback: (html: string) => void
    ) {
        /* Formular zum Editieren eines Markers aufbauen */
        $.post(systemurl + 'app/module/googlemaps/gethtml', {
            moduleId : this.moduleId,
            type : type,
            title : title,
            content : content,
            link : link,
            address : address,
            lat : lat,
            lng : lng
        }, function(response) {
            if (callback) {
                callback(response.html);
            }
        }, 'json');
    }
    infoWindowContentUI() {
        $('.gmapInfoWindowGutter1 button').button();
        $('.gmapInfoWindowGutter2 .gmap-box-footer a').button();
        //$('.gmapInfoWindowGutter1 #marker_linker_icon').button({
        //    'icons': {
        //        'primary': 'ui-icon-1and1-link'
        //    },
        //    'text': false
        //});
        $('.gmapInfoWindowGutter1 #marker_title').bind("focus", function() {
            if ($(this).val() === l10n.getString('gmaps.new_destination')) {
                (this as HTMLInputElement).select();
            }
        });
        $('.gmapInfoWindowGutter1 #combobox-internerLink').diy_combobox({editable: false}).addClass('fullsize-input');
    }
    showLinkDialog() {
        /* Option zum Verlinken eines Marker-Titels ein- oder ausblenden */
        if ($('#marker_link_dialog:hidden').length > 0) {
            $('#marker_link_dialog').show();
        } else {
            $('#marker_link_dialog').hide();
        }
    }
    linkMarker() {
        /*
         * Temporäre Link-Variable auf den angegebenen externen Link
         * setzen;
         */
        /*
         * wenn keiner angegeben, stattdessen die ID der selektierten
         * internen Page nehmen
         */
        let link: string = null;
        if ($('#hyperlinkurl').val()) {
            link = $('#hyperlinkurl').val();
        } else {
            link = $('#internerLink').val();
        }
        this.marker_link = link;
        /* Link-Button auf Unlink umstellen */
        this.showLinkDialog();
        $('#marker_linker_icon').addClass('ui-icon-1and1-unlink').removeClass('ui-icon-1and1-link');
        $.post(systemurl + 'app/module/googlemaps/getlink',
                'moduleId=' + this.moduleId + '&link=' +
                        encodeURIComponent(link), function(response) {
                    $('#marker_link').html(response.link);
                }, 'json');
        $('#marker_linker_icon').attr('href',
                'javascript:mm[' + this.moduleId + '].unlinkMarker();');
    }
    unlinkMarker() {
        /* Link-Variable zuruecksetzen */
        this.marker_link = '';
        /* Unlink-Button auf Link umstellen */
        $('#marker_linker_icon').addClass('ui-icon-1and1-link').removeClass('ui-icon-1and1-unlink');
        $('#marker_link').html('');
        $('#marker_linker_icon').attr(
                'href', 'javascript:mm[' + this.moduleId + '].showLinkDialog();');
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulGooglemaps.ts
 **/